<template>
  <ocr-dialog
    :title="$t('SeaExport.PreviewOfBookingFileParsing')"
    custom-class="intelligent-booking-result-dialog"
    :visible.sync="innerVisible"
    fullscreen
    :width="'100%'"
    :top="'0vh'"
    :modal="false"
    :can-maximize="true"
    :can-minimize="true"
    :only-can-minimize="true"
    :append-to-body="true"
    :close-class="windowMin ?'padding-right: 980px':'padding-right: 1px'"
    @close="$emit('close')"
    @modalMin="windowMin = true"
    @restore="windowMin = false"
  >
    <!--    通用托书详情-->
    <intelligent-booking-result-common
      v-if="innerVisible"
      :visible="innerVisible"
      :details="detailList[0]"
      :source="source"
      style="width:100%;height: 100%;"
      @toNext="toNext"
      @close="$emit('close')"
      @success="$emit('success')"
      @copyIntelligentDocument="(res)=> { $emit('copyIntelligentDocument', res) }"
    />
    <!--    <div slot="footer" style="display: flex;justify-content: center;">-->
    <!--      &lt;!&ndash;分页&ndash;&gt;-->
    <!--      <el-pagination-->
    <!--        background-->
    <!--        style="right: 200px"-->
    <!--        :current-page.sync="pageNum"-->
    <!--        :pager-count="5"-->
    <!--        :page-size="1"-->
    <!--        layout="prev, pager, next, jumper"-->
    <!--        :total="total"-->
    <!--      />-->
    <!--    </div>-->
  </ocr-dialog>
</template>

<script>
import IntelligentBookingResultCommon from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/IntelligentBookingResultCommon'
import ocrDialog from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/ocrDialog.vue'

export default {
  name: 'IntelligentBookingResultMultiNew',
  components: { ocrDialog, IntelligentBookingResultCommon },
  props: {
    detailList: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      innerVisible: false,
      windowMin: false,
      pageNum: 1 // 当前页
    }
  },
  computed: {
    total() { // 总页数
      return this.detailList.length
    }
    // ,
    // innerVisible: {
    //   get() {
    //     return this.visible
    //   },
    //   set() {
    //     this.handleClose()
    //   }
    // }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
      },
      immediate: true
    }
  },
  methods: {
    toNext() {
      if (this.pageNum < this.detailList.length) {
        this.pageNum++
      }
    }
  }
}
</script>

<style lang="scss">
.intelligent-booking-result-dialog{
  min-width: 1200px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .el-dialog__body{
    padding: 0!important;
    display: flex;
    flex:1;
    overflow: hidden;
  }
}
</style>
